'use client';

import { c as _c } from "react/compiler-runtime";
import { useContext, useCallback } from 'react';
import { useRouter } from 'next/navigation';
import { ROTA_ABA_PLANO } from '@/features/contracts';
import { ImpersonationContext } from '@/features/admin-geral/contexts/ImpersonationContext';
import type { ImpersonationTarget } from '@/features/admin-geral/types/operacoes';
export const useImpersonation = () => {
  const $ = _c(18);
  const context = useContext(ImpersonationContext);
  const router = useRouter();
  let t0;
  if ($[0] !== context || $[1] !== router) {
    t0 = async (target, redirectTo) => {
      const success = await context.startImpersonation(target);
      if (success && redirectTo) {
        router.push(redirectTo);
      }
      return success;
    };
    $[0] = context;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const impersonate = t0;
  let t1;
  if ($[3] !== context || $[4] !== router) {
    t1 = async redirectTo_0 => {
      await context.stopImpersonation();
      router.push(redirectTo_0 ?? "/admin-geral");
    };
    $[3] = context;
    $[4] = router;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const exitImpersonation = t1;
  let t2;
  if ($[6] !== router) {
    t2 = () => {
      router.push(ROTA_ABA_PLANO);
    };
    $[6] = router;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const abrirPlanoDoWorkspace = t2;
  let t3;
  if ($[8] !== abrirPlanoDoWorkspace || $[9] !== context.isImpersonating || $[10] !== context.targetTenantId || $[11] !== context.targetTenantNome || $[12] !== context.targetUserEmail || $[13] !== context.targetUserId || $[14] !== context.targetUserNome || $[15] !== exitImpersonation || $[16] !== impersonate) {
    t3 = {
      isImpersonating: context.isImpersonating,
      targetUserId: context.targetUserId,
      targetUserNome: context.targetUserNome,
      targetUserEmail: context.targetUserEmail,
      targetTenantId: context.targetTenantId,
      targetTenantNome: context.targetTenantNome,
      impersonate,
      exitImpersonation,
      abrirPlanoDoWorkspace
    };
    $[8] = abrirPlanoDoWorkspace;
    $[9] = context.isImpersonating;
    $[10] = context.targetTenantId;
    $[11] = context.targetTenantNome;
    $[12] = context.targetUserEmail;
    $[13] = context.targetUserId;
    $[14] = context.targetUserNome;
    $[15] = exitImpersonation;
    $[16] = impersonate;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
};